<template>
  <div class="coupon-report-list" id="coupons">
    <div class="animated fadeIn">
      <LoadingIcon :showLoading="showLoading"></LoadingIcon>

      <b-row>
        <b-col cols="12">
          <div class="row mt-2">
            <div class="col-sm-10 col-form-label report-title">
                <span class="title-green">{{ $t('report.coupon_reports') }}&nbsp</span> / <span class="title-black">&nbsp{{ $t('report.coupon_redemption_report') }}</span> 
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row >
        <b-col cols="12">
          <b-card class="mt-2 header-box">
            <b-col cols="12">
              <FilterComponent @onChange="handleFilterEvent" />
            </b-col>
            <b-col cols="12" class="mt-3">
              <div class="d-flex align-items-center">
                <fieldset class="date-range-box-coupon-reports ml-auto">
                  <legend class="date-range-text">{{ $t('report.filter_date_range_text') }}</legend>
                  <b-input-group style="border: none !important;">
                    <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" opens="left" :locale-data="date_locale" :ranges="ranges" @update="refreshData"></date-range-picker>
                  </b-input-group>
                </fieldset>
                <button class="btn btn-success" @click="getCouponRedemptionReportDetails">{{ $t('common.show_coupons') }}</button>
                <button class="btn btn-success" @click="exportCSV">{{ $t('common.export_csv') }}</button>
              </div>
            </b-col>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mb-4 mt-4">
        <b-col>
          <template v-if="dataTable.items.length">
            <md-table v-model="dataTable.items" md-card>
              <md-table-row >
                <md-table-head
                  v-for="field in dataTable.fields"
                  :key="field.name">
                  {{ $t(field.label) }}
                </md-table-head>
              </md-table-row>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell
                  v-for="field in dataTable.fields"
                  :key="field.name"
                  :md-label="$t(field.label)" >
                  <span
                    v-html="handleShowValue(field, item)"
                    @click="handleShowClick(field, item)"
                    :class="handleShowClass(field)">
                  </span>
                </md-table-cell>
              </md-table-row>
            </md-table>

            <CPagination
              v-model:perPage="pagination.perPage"
              :currentPage="pagination.currentPage"
              :per-page.sync="pagination.perPage"
              :current-page.sync="pagination.currentPage"
              :totalPages="pagination.totalPages"
              :total="pagination.total"
              :totalItems="dataTable.items.length"
              :options="pagination.options"
              />
          </template>

          <template v-else>
            <md-table md-card>
              <md-table-row >
                <md-table-head
                  v-for="field in dataTable.fields"
                  :key="field.name">{{ $t(field.label) }}
                </md-table-head>
              </md-table-row>
            </md-table>
            <md-card>
              <b-row>
                <b-col class=" text-center my-4">
                  <p>{{ $t('report.coupon_tb_no_items') }}</p>
                </b-col>
              </b-row>
            </md-card>
          </template>
        </b-col>
      </b-row>
    </div>
    <websocket :source="`${this.$auth.user().user_info.user.email}`" :path="wsPath" :callback="getCouponsFromSocket" :onConnectedOnce="getCouponRedemptionReportDetails"></websocket>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'
import DateRangePicker from 'vue2-daterange-picker'
import PieChart from '@/components/Partials/PieChart'
import CPagination from '@/components/Partials/CPagination'
import FilterComponent from './components/FilterComponent.vue'
import { ExportToCsv } from 'export-to-csv'
import Websocket from '@/components/Websocket.vue'
import LoadingIcon from '@/components/Partials/Loading'
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

let vm = null
const VUE_SESSION_KEY = "vue-session-key";
const CONFIG_BASE_ID = "config.base.id";
const DIPOSITION_DELIVERY_TEXT = 'Delivery'
const DIPOSITION_TAKEAWAY_TEXT = 'Takeaway'
const DIPOSITION_PICKUP_TEXT = 'Pick-up';
const CHANNEL_LABEL_APP = 'App';
const CHANNEL_LABEL_WEB = 'Web';
const DIPOSITION_DELIVERY = 'D'
const TABLE_HEADER_KEY = {
  0: 'date',
  1: 'coupon_type',
  2: 'parent_coupon_code',
  3: 'child_coupon_code',
  4: 'store_name',
  5: 'total_amount',
  6: 'deposition',
  7: 'channel',
  8: 'customer_email',
  9: 'customer_id',
  10: 'order_number',
}

export default {
  name: 'CouponRedemptionReport',
  components: {
    DateRangePicker,
    PieChart,
    CPagination,
    FilterComponent,
    Websocket,
    LoadingIcon
  },
  data: function () {
    const sessionId = uuidv4()
    return {
      showLoading: false,
      sessionId,
      wsPath:
        `&TargetId=GMS_COUPON_REPORT_${localStorage.getItem('clientID')}_${this.$auth.user().user_info.user.email}_${sessionId}`,
      pagination: {
        options: [10, 20, 50, 100],
        currentPage: 1,
        total: 0,
        totalPages: 0,
        perPage: 10,
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: TABLE_HEADER_KEY[0],
            label: 'report.coupon_tb_date',
            customValue: (item) => {
              return this.$moment(item[TABLE_HEADER_KEY[0]]).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            name: TABLE_HEADER_KEY[1],
            label: 'report.coupon_tb_coupon_type',
            customValue: (item) => {
              this.listOfCouponTypes.forEach((currentval,idx)=>{
                if(currentval.id == item[TABLE_HEADER_KEY[1]]) {	
                  item = currentval.name.en;	
                  return false;	
                }	
              });	
              return item;
            }
          },
          {
            name: TABLE_HEADER_KEY[2],
            label: 'report.coupon_tb_parent_code',
            redirectTo: 'coupon_edit',
            customValue: (item) => {
              return item[TABLE_HEADER_KEY[2]]
            }
          },
          {
            name: TABLE_HEADER_KEY[3],
            label: 'report.coupon_tb_child_code'
          },
          {
            name: TABLE_HEADER_KEY[4],
            label: 'report.coupon_tb_store_name',
            customValue: (item) => {
              if (item.store_code && item.store_name) {
                return `${item.store_code} - ${item.store_name}`;
              } else if (item.store_code && !item.store_name) {
                return item.store_code;
              } else if (!item.store_code && item.store_name) {
                return item.store_name;
              } else {
                return '';
              }  
            }
          },
          {
            name: TABLE_HEADER_KEY[5],
            label: 'report.coupon_tb_total_amount',
            customValue: (item) => {
              return new Intl.NumberFormat().format(item.total_amount)
            }
          },
          {
            name: TABLE_HEADER_KEY[6],
            label: 'report.coupon_tb_disposition',
            customValue: (item) => {
              return item[TABLE_HEADER_KEY[6]] === DIPOSITION_DELIVERY ? DIPOSITION_DELIVERY_TEXT : DIPOSITION_TAKEAWAY_TEXT
            }
          },
          {
            name: TABLE_HEADER_KEY[7],
            label: 'report.coupon_tb_chanel'
          },
          {
            name: TABLE_HEADER_KEY[8],
            label: 'report.coupon_tb_customer'
          },
          {
            name: TABLE_HEADER_KEY[9],
            label: 'report.coupon_tb_customer_id'
          },
          {
            name: TABLE_HEADER_KEY[10],
            label: 'report.coupon_tb_order_number'
          }
        ],
      },
      filter: {
        startAt: this.$moment().subtract(7,'d').format('YYYY-MM-DD'),
        endAt: this.$moment().format('YYYY-MM-DD'),
        customer_email: '',
        parent_coupon_code: '',
        coupon_type: '',
        store_code: ''
      },
      chartdataChannel: {},
      dispositionUsageChartdata: {},
      storeChartdata: {},
      totalCouponsUsed:0,
      totalPublishedCampaigns:0,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
            }
          }
        },
        legend : {
          position: "right"
        }
      },
      storeChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return ` ${data['datasets'][0]['data'][tooltipItem['index']]}`;
            }
          }
        },
        legend : {
          position: "right"
        }
      },
      reportData: [],
      listOfCouponTypes: [],
      checkExportDisableCondition: true
    }
  },
  methods: {
    handleShowValue(field, item) {
      return field.hasOwnProperty('customValue')
                      ? field.customValue(item)
                      : item[field.name]
    },
    handleShowClick(field, item) {
      if (field.hasOwnProperty('redirectTo')) {
        return field.name === TABLE_HEADER_KEY[2] && this.handleRedirectTo(field.redirectTo, { id: item.parent_coupon_uuid })
      }
      return
    },
    handleShowClass(field) {
      return field.hasOwnProperty('redirectTo') ? 'is-redirect' : ''
    },
    handleRedirectTo(routeName, params) {
      const routeData = this.$router.resolve({ name: routeName, params: params })
      window.open(routeData.href, '_blank');
    },
    handleFilterEvent(dataEvent) {
      const {
        customerEmail: customer_email,
        parentCouponCode: parent_coupon_code,
        couponTypeCode: coupon_type,
        storeCode: store_code } = dataEvent
      this.filter = {
        ...this.filter,
        customer_email,
        parent_coupon_code,
        coupon_type,
        store_code
      }
      vm.pagination.currentPage = 1
    },
    getCouponRedemptionReportDetails() {
      this.showLoading = true
      this.applyDate()
      const {customer_email, parent_coupon_code, coupon_type, store_code } = vm.filter
      let _data = {
        session_id: vm.sessionId,
        client_id: vm._.get(JSON.parse(localStorage.getItem(VUE_SESSION_KEY)), CONFIG_BASE_ID, 0),
        from_date: vm.filter.startAt,
        to_date: vm.filter.endAt,
        limit: vm.pagination.perPage,
        page: vm.pagination.currentPage,
        customer_email,
        parent_coupon_code,
        coupon_type,
        store_code,
        email_request: `${this.$auth.user().user_info.user.email}`
      };

      const diff = (this.$moment(vm.filter.endAt)).diff(this.$moment(vm.filter.startAt),  'months')
      if (diff > 3) {
        vm.$toastr.error(vm.$t('report.rule_query_coupons'), vm.$t('message.error'), {})
        this.showLoading = false
      } else {
        // process to send via get method
        let params = '';
        for (let key in _data) {
          params += key + '=' + _data[key] + '&'
        }
        params = params.slice(0, -1);
        vm.axios.report.getCouponRedemptionReportDetails(params, function (response) {});
      }
    },
    getCouponsFromSocket(data) {
      // export coupons
      if (data.action != undefined && data.action == 'EXPORT' && data.export_path != "") {
        let params = `path=${data.export_path}&email_request=${this.$auth.user().user_info.user.email}`
        vm.axios.report.exportCouponRedemptionReportDetails(params, function (response) {
          if (response.status == 200) {
            // download file
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'file-coupons.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          } else {
            vm.$toastr.error(vm.$t('trigger_fcds_build.error_message'), vm.$t('message.error'), {})
          }
        });
      }

      // query coupons
      if (data.items != undefined) {
        vm.reportData = data.items;
        const items = data.items
        const pagination = data._metadata
        vm.dataTable.items = items

        const totalPage = Math.ceil(pagination.total/pagination.page_size)
        vm.pagination = {
          ...vm.pagination,
          currentPage: +pagination.page_number,
          total: +pagination.total,
          totalPages: +totalPage,
          perPage: +pagination.page_size,
        }
        vm.totalCouponsUsed = pagination.total;
        vm.checkExportDisableCondition = vm.totalCouponsUsed > 0 ? false : true;
      }
      this.showLoading = false
    },
    refreshCards() {
      //Channel Stats
      let app = vm.reportData.card_info.channel.android;
      let ios = vm.reportData.card_info.channel.ios;
      let web = vm.reportData.card_info.channel.web;
      let total = vm.reportData.card_info.channel.total;
      let appPercentage = ((app+ios)*100/total).toFixed();
      let webPercentage = (web*100/total).toFixed();
      //Disposition Stats
      let collection = vm.reportData.card_info.disposition.collection;
      let delivery = vm.reportData.card_info.disposition.delivery;
      let totalDisposition = vm.reportData.card_info.disposition.total;
      let deliveryRate = (delivery*100/totalDisposition).toFixed();
      let collectionRate = (collection*100/totalDisposition).toFixed();

      const storeLabels = []
      const storeData = []

      // top 5 stores
      vm.reportData.card_info.top_five_stores.map(store => {
        const label = `${store.storeCode} - ${store.storeName}`
        const value = store.count
        storeLabels.push(label)
        storeData.push(value)
      })

      vm.chartdataChannel = {
        labels: [CHANNEL_LABEL_APP, CHANNEL_LABEL_WEB],
        datasets: [
          {
            label: "Channel Redemption Data",
            backgroundColor: ['#67C587','#A9DEBA'],
            data: [appPercentage, webPercentage]
          }
        ]};
      vm.dispositionUsageChartdata = {
        labels: [vm.$t('report.delivery_text'), vm.$t('report.pick_up_text')],
        datasets: [
          {
            label: "Disposition Usage",
            backgroundColor: ['#67C587','#A9DEBA'],
            data: [deliveryRate, collectionRate]
          }
        ]
      },
      vm.storeChartdata = {
        labels: storeLabels,
        datasets: [
          {
            backgroundColor: ['#67C587','#88D1A0','#A9DEBA','#C9EAD4', '#EAF6ED'],
            data: storeData
          }
        ]
      },
      vm.totalPublishedCampaigns = vm.reportData.card_info.active_parent_coupon.total;
      vm.totalCouponsUsed = vm.reportData.card_info.disposition.total;
      vm.checkExportDisableCondition = vm.totalCouponsUsed > 0 ? false : true;
    },
    refreshData(val) {
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      vm.pagination.currentPage = 1
    },
    applyDate() {
      let dateRange = document.querySelector('.glyphicon.glyphicon-calendar.fa.fa-calendar ~ span')
      if (dateRange != undefined) {
        dateRange = dateRange.innerHTML
        dateRange = dateRange.split('-')
        this.filter.startAt = this.$moment(dateRange[0].trim(), 'YYYY/MM/DD').format('YYYY-MM-DD')
        this.filter.endAt = this.$moment(dateRange[1].trim(), 'YYYY/MM/DD').format('YYYY-MM-DD')
      }
    },
    exportCSV() {
      this.showLoading = true
      this.applyDate()
      const { customer_email, parent_coupon_code, coupon_type, store_code } = vm.filter
      const queries = {
        session_id: vm.sessionId,
        client_id: vm._.get(JSON.parse(localStorage.getItem(VUE_SESSION_KEY)), CONFIG_BASE_ID, 0),
        from_date: vm.filter.startAt,
        to_date: vm.filter.endAt,
        limit: vm.pagination.total,
        page: 1,
        customer_email,
        parent_coupon_code,
        coupon_type,
        store_code,
        email_request: `${this.$auth.user().user_info.user.email}`,
        export_file: 1
      };

      const yearEnd = this.$moment(vm.filter.endAt).year()
      const yearStart = this.$moment(vm.filter.startAt).year()
      const diff = (this.$moment(vm.filter.endAt)).diff(this.$moment(vm.filter.startAt),  'days')
      if (yearEnd != yearStart && diff > 8) {
        vm.$toastr.error(vm.$t('report.rule_export_coupons'), vm.$t('message.error'), {})
        this.showLoading = false
      } else {
        let params = '';
        for (let key in queries) {
          params += key + '=' + queries[key] + '&'
        }
        params = params.slice(0, -1);
        vm.axios.report.getCouponRedemptionReportDetails(params, function (response) {})
      }
    },
    getListOfAllCouponTypes() {
      vm.axios.coupon.getAllCouponTypes(response => {
        vm.listOfCouponTypes = response.data.data.items;
      });
    },
    csvExportConfig() {
      return {
        fieldSeparator: ',',
        filename: this.$t('coupon.coupon'),
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: [
          this.$t('report.coupon_tb_date'),
          this.$t('report.coupon_tb_coupon_type'),
          this.$t('report.coupon_tb_parent_code'),
          this.$t('report.coupon_tb_child_code'),
          this.$t('report.coupon_tb_store_name'),
          this.$t('report.coupon_tb_total_amount'),
          this.$t('report.coupon_tb_disposition'),
          this.$t('report.coupon_tb_chanel'),
          this.$t('report.coupon_tb_customer'),
        ]
      }
    }
  },
  computed: {
    date_locale: function () {
      let format = this.format_date_range_locale();
      format.format = 'YYYY/MM/DD';
      if (this.$refs.drange) {
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges: function () {
      return this.format_date_ranges()
    },
    spacingBottom: function() {
      if(this.totalPublishedCampaigns != 0){
        return 'mt-109';
      } else {
        return 'mt-62';
      }
    },
    spacingTop: function() {
      if(this.totalPublishedCampaigns != 0){
        return 'mt-115';
      } else {
        return 'mt-70';
      }
    }
  },
  created: function () {
    vm = this;
    vm.getListOfAllCouponTypes();
    vm.couponRedmptionReportChangeLang = () => {
      // if(vm.reportData.card_info) {
      //   vm.refreshCards()
      // }
    }
    vm.$root.$on('changeLang', vm.couponRedmptionReportChangeLang)
  },
  beforeDestroy() {
    vm.$root.$off('changeLang', vm.couponRedmptionReportChangeLang)
  },
  watch: {
    'pagination.perPage': function (_) {
      this.pagination.currentPage = 1
      this.getCouponRedemptionReportDetails();
    },
    'pagination.currentPage': function(_) {
      this.getCouponRedemptionReportDetails();
    }
  }
}
</script>

<style scoped>
.coupon-report-list ::selection{
  background-color: #d7d7d7 !important;
  color: #000;
}
.header-box{
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}
.report-card {
  text-align: center
}
.card-details {
  text-align: center;
  font-size: 26px;
}
.card-number-stats{
  font-weight: 700;
  font-size: 38px!important;
  line-height: 32px!important;
}
.card-heading-stats{
  /* font-family: 'Sharp Sans Display No1'; */
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #231F20;
}
.btn-success{
    color: #fff;
    background-color: #0A8020 !important;
    border-color: #4dbd74;
    font-size: 0.85rem;
    margin-top: 8px;
    margin-left: 25px;
    height: 40px;
}

h4 {
  display: inline-block;
}

.is-redirect:hover {
  color: #4dbd74;
  cursor: pointer;
}

.mt-62 {
  margin-top: 62px !important
}

.mt-109 {
  margin-top: 109px !important
}

.mt-115 {
  margin-top: 115px !important
}

.mt-70 {
  margin-top: 70px !important
}
.ml-30 {
  margin-left: 30px;
  height: 57px;
}
.report-title {
  /* font-family: 'Sharp Sans Display No1'; */
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center; 
} 
.title-green {
  color : #038900;
} 
.title-black {
  color : #000000;
}
.date-range-box-coupon-reports {
  border: 1px solid #00000026;
  border-radius: 3px;
  /* margin-top: 10px; */
  width: max-content;
}
.date-range-text {
  font-size: 12px;
  margin-left: 10px;
  width: max-content;
  color:#6B6E79;
  margin-bottom: -3px;
}
</style>
<style>
.md-table-head{
  color: #000000 !important;
}

.date-range-box-coupon-reports > .input-group > div > div.form-control {
  border: none !important;
}
.daterangepicker.dropdown-menu.show-calendar .drp-buttons {
  display: none;
}
#coupons {
  position: relative
}
</style>



// WEBPACK FOOTER //
// src/views/admin/report/CouponRedemptionReport.vue